module.exports = __webpack_public_path__ + "static/media/panda-ci-big.a799bdc9.png";